import { Component, OnInit, Input } from '@angular/core';
import { Data, Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { DomSanitizer } from '@angular/platform-browser';

import {plainToClass} from 'class-transformer';
import { Img } from '../../../shared/data/img';
import { Config } from '../../../config/config';
import { NbIconLibraries } from '@nebular/theme';
import { ApiService } from '../../../shared/api.service';
import { Ecole } from '../../../shared/data/ecole';
import { Critere } from '../../../shared/data/critere';
import { PaysService } from '../../../shared/pays.service';
import { EditCritereComponent } from '../../criteres/edit-critere/edit-critere.component';
import { EditFormationComponent } from '../../formations/edit-formation/edit-formation.component';
import { Formation } from '../../../shared/data/formation';
import { EditAdmissionComponent } from '../edit-admission/edit-admission.component';
import { Admission } from '../../../shared/data/admission';
import swal from 'sweetalert2';
import { LocalDataSource } from 'ng2-smart-table';
import { EditFaculteComponent } from '../edit-faculte/edit-faculte.component';
import { Faculte } from '../../../shared/data/faculte';

@Component({
  selector: 'ngx-edit-ecole',
  templateUrl: './edit-ecole.component.html',
  styleUrls: ['./edit-ecole.component.scss']
})
export class EditEcoleComponent implements OnInit {
  @Input() id: number;
  model;

  /* description;

  slug;
  titre;
  datePublish; */
  heure = "15";
  minute = "22";
  ecole = new Ecole;
  hideButon = false;
  hideLoader = true;
  //photoSelected: Img; 

  url: string

  config = Config;
  
  // isPublish = false;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'titre',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  formations: Formation[] = [];
  options: Critere[] = [];

  source: LocalDataSource =  new LocalDataSource();
  settings = {
 
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
     },
     add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
     edit: {
       editButtonContent: '<i class="nb-edit"></i>',
       saveButtonContent: '<i class="nb-checkmark"></i>',
       cancelButtonContent: '<i class="nb-close"></i>',
       confirmSave:false
     },
     delete: {
       deleteButtonContent: '<i class="nb-trash"></i>',
       confirmDelete: true,
     },
   columns: {
     /* id: {
       title: 'ID',
       type: 'number',
       filter: false,
     }, */
     cycle: {
       title: 'Cycle',
       type: 'string',
     },
     labelfaculte: {
      title: 'Faculté',
      type: 'string',
    },
    /* label_categorie: {
      title: 'Categorie',
      type: 'string',
    }, */
    /* labelAdmission: {
      title: 'Admission',
      type: 'string',
    }, */
   /*  is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    }, */
  
   },
   pager : {
                 perPage :10
   },
  
  };

  imageselect = '';
  imageTab:Img[] =[];
  
  constructor(public paysService: PaysService, iconsLibrary: NbIconLibraries, private sanitizer: DomSanitizer,private dialogService: NbDialogService,protected dialogRef: NbDialogRef<EditEcoleComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr:NbToastrService ) { 
  
    this.url = Config.urlserveur;
    iconsLibrary.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('ion', { iconClassPrefix: 'ion' });

    this.model = this.ecole.converDatePublishToNgbDateStruct;

    // this.getEcole();


  
  }

  ngOnInit() {


    this.apiService.getAllCritereProvider('').subscribe(data =>{
     
      this.options = data;

    })

    this.sendeurService.image.next(null);
  
    if(this.id !== 0)
    this. getOneEcole();
  
    // console.log(this.model);

    this.sendeurService.image.asObservable().subscribe(data =>{
      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);
      // this.photoSelected = plainToClass(Img, data as object);
      // this.ecole.photo = plainToClass(Img, data as object);

      // console.log(this.photoSelected);
      
      // alert("");

      if( this.imageselect === 'photo' && data !== null && data.url !== null) {

        this.ecole.photo = data;

      }

      if( this.imageselect === 'images' && data !== null && data.url !== null) {


        if( this.ecole.images !== undefined && this.ecole.images !== null){

          const itemIndexPr = this.ecole.images.findIndex(item => item.url === data.url);

          if ( itemIndexPr === -1 ) {
            // this.projet.photo = data;
            this.ecole.images.push(data);
            // console.log(this.projet);
          }

        } else {

          this.ecole.images = []
          this.ecole.images.push(data);
        }

        this.imageTab = plainToClass( Img, this.ecole.images);

        // console.log(this.imageTab);

      }
      
    })

    this.sendeurService.critereEvent.subscribe( data => {

      console.log(data)
      
      const index = this.options.findIndex(elem => elem.id ===  data.id);

      if(index === -1 ) {

        this.options.push(data);

        if(data.type_critere === 'type_ecole')
        this.ecole.type = data.id;

        if(data.type_critere === 'secteur')
        this.ecole.secteur = data.id;

        if(data.type_critere === 'pays')
        this.ecole.pays = data.id;

        if(data.type_critere === 'particularity')
        this.ecole.particularities.push(data.id);

        if(data.type_critere === 'partner')
        this.ecole.partenaires.push(data.id);
        

      }

    })


    this.sendeurService.admissionEvent.subscribe( data => {

      console.log(data)
      
      const index = this.ecole.admissions.findIndex(elem => elem.id ===  data.id);

      if(index === -1 ) {

        const row = {
          id: data.id,
          cycle: data.labelcycle,
          labelfaculte: data.labelfaculte,
        }
        this.ecole.admissions.push(row);

      } else {
        const row = {
          id: data.id,
          cycle: data.labelcycle,
          labelfaculte: data.labelfaculte,
        }
        this.ecole.admissions[index] = row;
      }

      this.source.load( this.ecole.admissions );

    })


    this.sendeurService.facultEvent.subscribe( data => {

      // console.log(data)
      
      const index = this.ecole.facultes.findIndex(elem => elem.id ===  data.id);

      if(index === -1 ) {

        const row = {
          id: data.id,
          nom: data.nom,
        }
        this.ecole.facultes.push(row);

      } else {

        const row = {
          id: data.id,
          nom: data.nom,
        }

        this.ecole.facultes[index] = row;
      }


    })


    
    this.getFormations();

    

   
  }

  

  updateEcole(){

      console.log(this.model)
      // return;

      this.hideButon = true;
      this.hideLoader = false;
    /* var data = JSON.parse(localStorage.getItem("image"));
    if(!JSON.parse(localStorage.getItem("image"))){
    
      this.toastr.danger(" vous devez choisir une image");
      this.hideButon = false;
      this.hideLoader = true;
      return false;
    } */
    if(this.model!== undefined){

      this.ecole.date_publish = {
       "date": {
          "year": this.model.year,
          "month": this.model.month,
          "day": this.model.day 
       },
       "time": {
          "hour": 0,
          "minute": 0
       }
     }

    }


  //  this.datePublish = this.model.year +'/'+this.model.month+'/'+this.model.day

   
  /*  console.log(data);
   console.log(data.baseUrl);
   this.photoSelected.path = data.path;
  this.photoSelected.baseUrl = data.baseUrl;
   this.photoSelected.hash = data.hash;
   this.photoSelected.mime = data.mime;
   this.photoSelected.name = data.name;
   this.photoSelected.phash = data.phash;
   this.photoSelected.size = data.size;
   this.photoSelected.tmb = data.tmb;
   this.photoSelected.ts = data.ts;
   this.photoSelected.url = data.url; */
  
   
   if(this.id !== 0) {

    this.apiService.updateEcoleProvider(this.ecole).subscribe((data: Ecole) =>{
      console.log(data);
      this.dialogRef.close();
      /* this.sendeurService.fichier.next(null); */
      this.toastr.success("mise à jour réussie","success");
      localStorage.removeItem("image");
      this.sendeurService.sendEcoleEvent(data);
    },(err) =>{
      console.log(err);
      this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
      this.hideButon = false;
      this.hideLoader = true;
      if(err.error.code ===401){
       localStorage.clear();
       window.location.reload();
       let link2 = ['/login'];
       this.router.navigate(link2);
     }
 
     if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
     
    })

   } else {

    this.apiService.addEcoleProvider(this.ecole).subscribe((data: Ecole) =>{
      console.log(data);
      this.dialogRef.close();
      this.toastr.success("ecole crée avec success", "success");
      /* localStorage.removeItem("fichier"); */
      /* this.sendeurService.fichier.next(null);*/
      this.sendeurService.sendEcoleEvent(data); 
    },(err) =>{

     this.hideButon = false;
     this.toastr.danger("il se peut qu'une ecole porte déjà le meme nom", "erreur")
      console.log(err);
      if(err.error.code ===401){
       localStorage.clear();
       window.location.reload();
       let link2 = ['/login'];
       this.router.navigate(link2);
     }
 
     if(err.error.code ===500){
      this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
  
    })

   }
   
  }


  selectImage(){
    // localStorage.setItem("photo","image");
    this.imageselect = 'photo';
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }

  
  addImages(){
    // this.tableau= [];
    // localStorage.setItem("photo","image");
    // this.image = true;
    this.imageselect = 'images';
    
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }


  getOneEcole(){
    this.apiService.getOneEcoleProvider(this.id).subscribe((data: Ecole) =>{

      this.ecole = plainToClass(Ecole, data as object);
      this.model = this.ecole.converDatePublishToNgbDateStruct;
   
      this.imageTab = plainToClass( Img, this.ecole.images);
      this.source.load( this.ecole.admissions );

      console.log(this.selectedItems);
      // console.log(this.page.converDatePublishToNgbDateStruct);
      
    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }


  cancel(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }

  close(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }

  
  onDropDownClose($event){
    
  }

  getFormations(){

    this.apiService.getAllformationProvider('').subscribe(data =>{
      
      this.formations = data;

    })
  
  }


  addType() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'type_ecole'}});
  }

  addSecteur() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'secteur'}});
  }

  addPays() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'pays'}});
  }

  addParticularity() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'particularity'}});
  }

  addPartner() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'partner'}});
  }

  addAdmission() {
    const closeOnBackdropClick = false;
    this.dialogService.open(EditAdmissionComponent,{closeOnBackdropClick, context:{id:0, ecole: this.ecole.id, facultes: this.ecole.facultes}});
  }

  editAdmission(idadmission) {
    const closeOnBackdropClick = false;
    this.dialogService.open(EditAdmissionComponent,{closeOnBackdropClick, context:{id:idadmission, ecole: this.ecole.id, facultes: this.ecole.facultes}});
  }

  deleteAdmision(admission: Admission){
    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    
    swal({
      title: 'Suppression admission',
      text: 'Voulez - vous vraiment supprimer ' + admission.cycle + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteAdmissionProvider(admission.id).subscribe(data =>{
          
          // console.log(data);
          const index = this.ecole.admissions.findIndex(elem => elem.id ===  admission.id);

          if(index !== -1 ) {

            this.ecole.admissions.splice(index, 1);

          }

          this.source.load( this.ecole.admissions );

          this.toastr.success("Supprimé(e)", admission.cycle);
         
        },(err) =>{
          
          this.toastr.danger("Echec de suppréssion ");
          
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        /* this.toastr.success("Supprimé(e)", ecole.titre); */

      }

      // this.dialogIsNotShow = false;

    });
  
  }


  onDelete(event){ 

    // console.log(event);

    this.deleteAdmision(event.data);
  
  }

  select(event){
    this.editAdmission(event.data.id)
  }

  onCreate(event){
    this.addAdmission();
  }


  addFaculte() {
    this.dialogService.open(EditFaculteComponent,{context:{id:0, ecole: this.ecole.id}});
  }

  editFaculte(idfacult) {
    this.dialogService.open(EditFaculteComponent,{context:{id:idfacult, ecole: this.ecole.id}});
  }


  deleteFaculte(faculte: Faculte){
    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    
    swal({
      title: 'Suppression faculté',
      text: 'Voulez - vous vraiment supprimer ' + faculte.nom + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteFaculteProvider(faculte.id).subscribe(data =>{
          
          // console.log(data);
          const index = this.ecole.facultes.findIndex(elem => elem.id ===  faculte.id);

          if(index !== -1 ) {

            this.ecole.facultes.splice(index, 1);

          }


          this.toastr.success("Supprimé(e)", faculte.nom);
         
        },(err) =>{
          
          this.toastr.danger("Echec de suppréssion ");
          
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        /* this.toastr.success("Supprimé(e)", ecole.titre); */

      }

      // this.dialogIsNotShow = false;

    });
  
  }

  deleteImage(img: Img) {
    
    const itemIndex = this.ecole.images.findIndex(item => item.url === img.url);
    if ( itemIndex > -1 ) {
      this.ecole.images.splice(itemIndex, 1);
      this.imageTab = plainToClass( Img, this.ecole.images);
    }

    // console.log( this.projet.images );

    // alert('');

  }


}
